'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGrowthHubOrCheckoutFlow = exports.getIsEmbeddedContentFlow = undefined;

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _appNames = require('../constants/appNames');

var _appNames2 = _interopRequireDefault(_appNames);

var _frame = require('../utils/frame');

var _isFunnel = require('../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: update selectors once global state has been moved to store
// !!! only possible after app is initialized !!!
// global SignupProduct state is null until router starts.
var getAppName = function getAppName() {
  return _AppConfigContainer2.default.get('appName');
};
var embeddedFlows = [_appNames2.default.academySignup, _appNames2.default.crmSignup, _appNames2.default.salesSignup, _appNames2.default.marketingSignup, _appNames2.default.serviceSignup];

var getIsEmbeddedContentFlow = exports.getIsEmbeddedContentFlow = function getIsEmbeddedContentFlow() {
  return embeddedFlows.includes(getAppName()) && (0, _frame.isFramed)() && !_isFunnel2.default.wordpress();
};

// from Authenticate.js
var isGrowthHubOrCheckoutFlow = exports.isGrowthHubOrCheckoutFlow = function isGrowthHubOrCheckoutFlow() {
  return _isFunnel2.default.growthHub() || _isFunnel2.default.checkout();
};